import { useReducer } from 'react';

/**
 * Generic handler to toggle a boolean state
 * @param {boolean} open - initial state
 * @returns {[boolean, Function]} the function is a useCallback type
 */
export function useToggle(open = false) {
  const [flag, toggle] = useReducer(
    (state) => !state,
    null,
    () => open
  );
  return [flag, toggle];
}
